import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import BrowsePage from "@/pages/BrowsePage";
import ProfessionalDetail from "@/pages/ProfessionalDetail";
import MatchPage from "@/pages/MatchPage";
import DashboardPage from "@/pages/DashboardPage";
import ProfileEditPage from "@/pages/ProfileEditPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import AboutPage from "@/pages/AboutPage";
import { TermsPage, PrivacyPage, FAQPage, ContactPage } from "@/pages/LegalPages";
import PricingPage from "@/pages/PricingPage";
import AdminBanner from "@/components/AdminBanner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return (
      <>
        <Header />
        <AuthCallback />
      </>
    );
  }
  return (
    <>
      <AdminBanner />
      <Header />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/professionals" element={<BrowsePage />} />
          <Route path="/professionals/:id" element={<ProfessionalDetail />} />
          <Route path="/match" element={<MatchPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/profile/edit" element={<ProtectedRoute><ProfileEditPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPage /></ProtectedRoute>} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#05070C] text-[#E8ECF3]">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
